import { Goal, GoalSortingMode, ID, OrderDirection } from '@griply/types';

import { getOrderedGoalIds } from '../get-ordered-goal-ids';
import { sortGoals } from '../sort-goals';

export type GetScopedGoalOrderOptions = {
  goals: Goal[];
  allGoals: Goal[];
  sortMode: GoalSortingMode;
  sortDirection: OrderDirection;
  goalSorting?: ID[] | null;
};

export const getScopedGoalOrder = ({
  goals,
  allGoals,
  sortMode,
  sortDirection,
  goalSorting,
}: GetScopedGoalOrderOptions): ID[] | undefined => {
  if (sortMode === GoalSortingMode.Custom) {
    return goalSorting ?? undefined;
  }

  const sorted = sortGoals(goals, { allGoals, sortMode });
  return getOrderedGoalIds(sorted, sortMode, sortDirection);
};
